import IconButton from "/src/components/UI/Button/IconButton/IconButton";
import './AreaBlockResponse.css';
import ResponseEdition from "../ResponseEdition/ResponseEdition";
import NiceModal from '@ebay/nice-modal-react';
import useShowRawInformation from "/src/features/editor/hook/useShowRawInformation";
import usePath from '/src/features/editor/hook/path/usePath';
import { useTreeStateContext } from "/src/features/editor/contexts/TreeContext";
import binarySearchString from "/src/features/editor/utils/binarySearchString";
import { useState } from "react";

function AreaBlockResponse(props) {
    const { searchPath, deletePath } = usePath();
    const { paths } = useTreeStateContext();
    var className = "pad";
    if (props.first) {
        className = className + ' avatar-' + props.type;
    }
    const editResponse = async (e) => {
        const isCustomResponse = props.isCustomResponseSet();
        const result = await NiceModal.show('editor-popup', {
            Component: ResponseEdition,
            componentProps: {
                content: props.content,
                index: props.first == true ? 0 : props.idx,
                type: props.type, isCustomResponse,
                is_not_link: props.is_not_link,
            }
        });
        const { data, index } = result;
        if (data.is_not_link != props.is_not_link && data.is_not_link == true) {
            let indexNextParent = binarySearchString(paths, props.object_block_id, 'child_block_id');
            if (paths[indexNextParent] !== undefined) {
                deletePath(paths[indexNextParent].path_id)
            }
        }
        props.setValue(index, data)
    }
    const [isHover, setIsHover] = useState(false);
    const content = props.content.split('->')[0]
    return (
        <div className="area-block-response" onMouseEnter={() => setIsHover(true)} onMouseLeave={() => setIsHover(false)}>
            <div className={className}></div>
            {props.type != 'raw' ? <span>{content}</span> : ''}
            {props.type == 'raw' ? useShowRawInformation('response', {}, '', 'Raw Response') : ''}
            <div className="actions">
                {
                    (isHover && props.idx != 0 && props.first != true) && <IconButton onClick={() => props.move(props.idx, -1)} className="editor-iconButton main_add-button button_center edit_action" icon="fas fa-chevron-up" />
                }
                {
                    (isHover && props.idx != - 1) && <IconButton onClick={() => props.move(props.idx, 1)} className="editor-iconButton main_add-button button_center edit_action" icon="fas fa-chevron-down" />
                }
                <IconButton className="editor-iconButton main_add-button button_center edit_action" icon="fas fa-edit" onClick={editResponse}></IconButton>
                <IconButton className="editor-iconButton main_add-button button_center delete_action" icon="fas fa-trash" onClick={() => props.deleteValue(props.first == true ? 0 : props.idx)}></IconButton>
            </div>
        </div>
    )
}

export default AreaBlockResponse;